import React from "react";
import Boot41Flow from "./Boot41Flow";
import Boot41Banner from "./Boot41Banner";

const Boot41FlowFrame = () => (
  <div className="md:w-[1200px] mx-auto md:mt-[64px] bg-transparent rounded-none shadow-none backdrop-filter-none flex flex-col items-stretch pb-[24px] box-border">
    <Boot41Flow />
    <Boot41Banner text="Kickstart Your AI Career" btntext="Apply Now" />
  </div>
);

export default Boot41FlowFrame;
